import styled from 'styled-components'

import background from '../../resources/img/background.png'

interface ColumnProps {
    center?: boolean
    color?: string | boolean
    left?: boolean
    margin?: boolean
    noOverflow?: boolean
    notFullHeight?: boolean
    padding?: string
    right?: boolean
    width?: string
    withBackground?: boolean
}

const Column = styled.div<ColumnProps>`
    display: inline-block;
    vertical-align: top;
    overflow-y: auto;
    position: relative;
    transition: width 0.3s;
    overflow-x: hidden;

    ${({ noOverflow = false }) => (noOverflow ? 'overflow-y: hidden;' : 'overflow-y: auto;')}

    ${({ notFullHeight = false }) => !notFullHeight && `height: 100%;`}

  ${({ left = false }) => left && `text-align: left;`}

  ${({ right = false }) => right && `text-align: right;`}

  ${({ center = false }) => center && `text-align: center;`}

  ${({ width = '50%' }) => `width: ${width};`}

  ${({ margin }) => `margin: ${margin};`}

  ${({ padding }) => `padding: ${padding};`}

  ${({ color, withBackground = false }) => {
        if (color && withBackground) {
            return `background: url(${background}) ${color};`
        }

        if (color) {
            return `background: ${color};`
        }

        if (withBackground) {
            return `background: url(${background});`
        }
    }}
`

export default Column
